// Feature-screen dispatch (task 3.6).
//
// The shell owns routing, the header, the bottom nav and the Home screen; it hands
// every non-home route here to render the real feature screen for that section and
// action. Each screen builder returns a DOM node immediately and fills itself in
// asynchronously (via the shared runAsync loading/error/empty states), so the shell
// can mount the result synchronously exactly as it did the old placeholders.
//
// Route shape (from ../router.js): { section, action: 'list'|'new'|'view', id }.
// Sections: clients, jobs, quotes, invoices (record sections with new/view) and
// settings (a single screen). 'home' is handled by the shell itself.

import { clientsListScreen, clientNewScreen, clientDetailScreen } from './clients.js';
import { jobsListScreen, jobNewScreen, jobDetailScreen } from './jobs.js';
import { quotesListScreen, quoteNewScreen, quoteDetailScreen } from './quotes.js';
import { invoicesListScreen, invoiceNewScreen, invoiceDetailScreen } from './invoices.js';
import { settingsScreen } from './settings.js';
import { voiceScreen } from './voice.js';

// Per-section builders keyed by action. 'view' builders receive the route id.
const SCREENS = {
  clients: { list: clientsListScreen, new: clientNewScreen, view: clientDetailScreen },
  jobs: { list: jobsListScreen, new: jobNewScreen, view: jobDetailScreen },
  quotes: { list: quotesListScreen, new: quoteNewScreen, view: quoteDetailScreen },
  invoices: { list: invoicesListScreen, new: invoiceNewScreen, view: invoiceDetailScreen },
  settings: { list: settingsScreen },
  // Voice-to-voice mode (task 7.3). A single screen; it owns its WebSocket + mic
  // lifecycle and exposes a __cleanup the shell calls when routing away.
  voice: { list: voiceScreen },
};

// Render the feature screen for a route, or null if the section isn't a feature
// section (the shell renders Home itself and falls back for anything unknown).
export function renderFeatureScreen(route) {
  const section = SCREENS[route.section];
  if (!section) return null;
  const builder = section[route.action] || section.list;
  return route.action === 'view' ? builder(route.id) : builder();
}
